import { Box } from "@mui/material";

import { useAuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import BusinessDropDown from "../BusinessDropDown";
import BusinessLoader from "../BusinessLoader";
import withObservables from "@nozbe/with-observables";
import { getBusinessFromUser } from "../../../database/helpers/business";
import { Sync } from "../../../SyncService";
import styles from "./styles.module.css";
import { LanguageContext } from "../../../context/LanguageContext";
import { ParagraphText } from "../../../Libraries";
import { CloseIcon, HeaderCloseIcon } from "../../../assets/icons/icon";
import {
  dismissMigrationBanner,
  shouldShowMigrationBanner,
} from "../../../utils/rupinMigrationBanner";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import ThemeToggle from "./ThemeToggle";

const AppTopHeader = ({
  allBusinesses,
  onMenuToggle,
  title = "RUPIN",
  isSidebarPinned = false,
}) => {
  const { user, business, setBusiness } = useAuthContext();
  const navigate = useNavigate();
  const [I18n] = useContext(LanguageContext);
  const [loadBusiness, setLoadBusiness] = useState(false);
  const [switchingTo, setSwitchingTo] = useState(null);
  const [allTempBusinesses, setAllTempBusinesses] = useState([]);
  const [showMigrationBanner, setShowMigrationBanner] = useState(false);

  useEffect(() => {
    fetchAllBusinesses();
  }, []);

  useEffect(() => {
    setShowMigrationBanner(shouldShowMigrationBanner());
  }, []);

  const fetchAllBusinesses = async () => {
    if (!user?.phone_number) {
      const businesses = await user?.business.fetch();
      setAllTempBusinesses(businesses);
    }
  };

  const handleDismissMigrationBanner = () => {
    dismissMigrationBanner();
    setShowMigrationBanner(false);
    triggerLogEvent(analytics, "rupin_migration_banner_dismissed");
  };

  const toggleBusiness = async (value) => {
    try {
      if (value.id != business.id) {
        setSwitchingTo({
          name: value.name || "",
          imageUrl: value.image_url || null,
        });
        setLoadBusiness(true);
        await value.activateBusiness();
        await business.deactivateBusiness();
        setBusiness(value);
        localStorage.setItem("business_id", value.id);
        Sync(user.phone_number, navigate).finally(() => {
          sessionStorage.setItem("skip_pin_verify", "true");
          window.location.href = "/BusinessOverview";
        });
      }
    } catch (e) {
      setSwitchingTo(null);
      setLoadBusiness(false);
    }
  };

  return (
    // <Box
    //   className={`${styles.header} ${
    //     showMigrationBanner ? styles.headerWithMigrationBanner : ""
    //   }`}
    // >
      <Box
      className={styles.header}
    >
      <BusinessLoader loadBusiness={loadBusiness} switchingTo={switchingTo} />
      <Box
        className={`${styles.left} ${
          isSidebarPinned ? styles.leftSidebarExpanded : ""
        }`}
      >
        {showMigrationBanner ? (
          <Box className={styles.migrationBanner}>
            <ParagraphText className={styles.migrationBannerText}>
              {I18n.rupin_migration_banner_message}
            </ParagraphText>
            <button
              type="button"
              className={styles.migrationBannerClose}
              id="rupin_migration_banner_close"
              aria-label="Close migration banner"
              onClick={handleDismissMigrationBanner}
            >
              <HeaderCloseIcon width={16} height={16} />
            </button>
          </Box>
        ) : null}
      </Box>
      <Box className={styles.right}>
        <Box className={styles.themeToggleCluster}>
          <ThemeToggle />
          <span className={styles.headerDivider} />
        </Box>
        <Box className={styles.headerProfile}>
          <BusinessDropDown
            setLoadBusiness={setLoadBusiness}
            toggleBusiness={toggleBusiness}
            allBusinesses={
              allTempBusinesses?.length ? allTempBusinesses : allBusinesses
            }
            business={business}
            navigate={navigate}
            user={user}
          />
        </Box>
      </Box>
    </Box>
  );
};

const enhance = withObservables([], ({}) => ({
  allBusinesses: getBusinessFromUser(localStorage.getItem("phone_number")),
}));

export default enhance(AppTopHeader);
